import { ContractNegotiationConcept } from '../../models/Entities/Contracts/ContractNegotiationConcept';
import { NewContractNegotiationConcept } from '../../models/Entities/Contracts/NewContractNegotiationConcept';
import { ErrorType } from '../../models/HttpError';
import * as Services from '../../services/ContractNegotiationConcept.Services';
import * as Actions from '../actions';
import { AppThunkAction } from '../reducers';

type KnownAction =
  | Actions.ContractNegotiationConcept.ContractNegotiationConcept_GetAll_Request_Action
  | Actions.ContractNegotiationConcept.ContractNegotiationConcept_GetAll_Receive_Action
  | Actions.ContractNegotiationConcept.ContractNegotiationConcept_GetAll_Error_Action
  | Actions.ContractNegotiationConcept.ContractNegotiationConcept_GetById_Request_Action
  | Actions.ContractNegotiationConcept.ContractNegotiationConcept_GetById_Receive_Action
  | Actions.ContractNegotiationConcept.ContractNegotiationConcept_GetById_Error_Action
  | Actions.ContractNegotiationConcept.ContractNegotiationConcept_Create_Request_Action
  | Actions.ContractNegotiationConcept.ContractNegotiationConcept_Create_Receive_Action
  | Actions.ContractNegotiationConcept.ContractNegotiationConcept_Create_Error_Action
  | Actions.ContractNegotiationConcept.ContractNegotiationConcept_Update_Request_Action
  | Actions.ContractNegotiationConcept.ContractNegotiationConcept_Update_Receive_Action
  | Actions.ContractNegotiationConcept.ContractNegotiationConcept_Update_Error_Action
  | Actions.ContractNegotiationConcept.ContractNegotiationConcept_Delete_Request_Action
  | Actions.ContractNegotiationConcept.ContractNegotiationConcept_Delete_Receive_Action
  | Actions.ContractNegotiationConcept.ContractNegotiationConcept_Delete_Error_Action;

const GetUnauthorizedError = (): ErrorType => ({
  ErrorCode: 401,
  ErrorMessage: 'Not authorized',
  Errors: [],
});

export const actionCreators = {
  GetContractNegotiationConcepts:
    (contractNegotiationId: string, contractId: number): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const state = getState();
      const token = state.oidc?.user?.access_token;

      if (!token) {
        dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_GET_ALL_ERROR_ACTION', contractNegotiationId, contractId, error: GetUnauthorizedError() });
        return;
      }

      dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_GET_ALL_REQUEST_ACTION', contractNegotiationId, contractId });

      Services.GetContractNegotiationConcepts(contractNegotiationId, token)
        .then((contractNegotiationConcepts: ContractNegotiationConcept[]) => {
          dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_GET_ALL_RECEIVE_ACTION', contractNegotiationConcepts, contractNegotiationId, contractId });
        })
        .catch((error: ErrorType) =>
          dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_GET_ALL_ERROR_ACTION', contractNegotiationId, contractId, error })
        );
    },

  GetContractNegotiationConceptById:
    (id: string, contractId: number): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const state = getState();
      const token = state.oidc?.user?.access_token;

      if (!token) {
        dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_GET_BY_ID_ERROR_ACTION', id, contractId, error: GetUnauthorizedError() });
        return;
      }

      dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_GET_BY_ID_REQUEST_ACTION', id, contractId });

      Services.GetContractNegotiationConceptById(id, token)
        .then((contractNegotiationConcept: ContractNegotiationConcept) => {
          dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_GET_BY_ID_RECEIVE_ACTION', contractNegotiationConcept, contractId });
        })
        .catch((error: ErrorType) =>
          dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_GET_BY_ID_ERROR_ACTION', id, contractId, error })
        );
    },

  CreateContractNegotiationConcept:
    (contractNegotiationConcept: NewContractNegotiationConcept, contractId: number): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const state = getState();
      const token = state.oidc?.user?.access_token;

      if (!token) {
        dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_CREATE_ERROR_ACTION', contractNegotiationConcept, contractId, error: GetUnauthorizedError() });
        return;
      }

      dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_CREATE_REQUEST_ACTION', contractNegotiationConcept, contractId });

      Services.CreateContractNegotiationConcept(contractNegotiationConcept, token)
        .then((saved: ContractNegotiationConcept) => {
          dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_CREATE_RECEIVE_ACTION', contractNegotiationConcept: saved, contractId });
        })
        .catch((error: ErrorType) =>
          dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_CREATE_ERROR_ACTION', contractNegotiationConcept, contractId, error })
        );
    },

  UpdateContractNegotiationConcept:
    (contractNegotiationConcept: ContractNegotiationConcept, contractId: number): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const state = getState();
      const token = state.oidc?.user?.access_token;

      if (!token) {
        dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_UPDATE_ERROR_ACTION', contractNegotiationConcept, contractId, error: GetUnauthorizedError() });
        return;
      }

      dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_UPDATE_REQUEST_ACTION', contractNegotiationConcept, contractId });

      Services.UpdateContractNegotiationConcept(contractNegotiationConcept, token)
        .then((updated: ContractNegotiationConcept) => {
          dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_UPDATE_RECEIVE_ACTION', contractNegotiationConcept: updated, contractId });
        })
        .catch((error: ErrorType) =>
          dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_UPDATE_ERROR_ACTION', contractNegotiationConcept, contractId, error })
        );
    },

  DeleteContractNegotiationConcept:
    (id: string, contractId: number, contractNegotiationId: string): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const state = getState();
      const token = state.oidc?.user?.access_token;

      if (!token) {
        dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_DELETE_ERROR_ACTION', id, contractId, contractNegotiationId, error: GetUnauthorizedError() });
        return;
      }

      dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_DELETE_REQUEST_ACTION', id, contractId, contractNegotiationId });

      Services.DeleteContractNegotiationConcept(id, token)
        .then(() => {
          dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_DELETE_RECEIVE_ACTION', id, contractId, contractNegotiationId });
        })
        .catch((error: ErrorType) =>
          dispatch({ type: 'CONTRACTNEGOTIATIONCONCEPT_DELETE_ERROR_ACTION', id, contractId, contractNegotiationId, error })
        );
    },
};
